// Site
exports.CLAIM = 'claim';
exports.PROCEDURE = 'procedure';
exports.BILL = 'bill';

exports.NOT_SEEN = 'not_seen';
exports.SEEN = 'seen';
exports.READ = 'read';

exports.PAYMENTS = 'payments';
exports.CLIENT_SUMMARY = 'client_summary';

exports.DIGITAL_BILL = 'DIGITAL_BILL';
exports.AUTOMATIC_DEBIT = 'AUTOMATIC_DEBIT';

exports.CARRIERS = [
  { id: '1', value: 'Movistar', name: 'Movistar', order: '1' },
  { id: '2', value: 'Nextel', name: 'Nextel', order: '2' },
  { id: '3', value: 'Personal', name: 'Personal', order: '3' },
  { id: '4', value: 'Claro', name: 'Claro', order: '4' }
];

exports.EMPTY_STRING = '';
